var _circle, _path, _path2, _path3, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10.3125,
    fill: "#ECB6FF",
    stroke: "#7D2B7C",
    strokeWidth: 1.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3198 4.94984C11.1817 3.95781 12.722 3.95781 13.5839 4.94984C14.0732 5.5129 14.8181 5.78402 15.5548 5.66716C16.8527 5.46126 18.0326 6.45134 18.0552 7.76532C18.0681 8.51112 18.4644 9.19762 19.1039 9.58164C20.2305 10.2582 20.498 11.7751 19.6707 12.7962C19.2012 13.3758 19.0635 14.1564 19.3065 14.8617C19.7347 16.1041 18.9645 17.4381 17.6744 17.6885C16.9422 17.8307 16.335 18.3402 16.0678 19.0366C15.5972 20.2636 14.1497 20.7904 13.0005 20.153C12.3482 19.7913 11.5555 19.7913 10.9032 20.153C9.75395 20.7904 8.30655 20.2636 7.83589 19.0366C7.56875 18.3402 6.96149 17.8307 6.22926 17.6885C4.93917 17.4381 4.16902 16.1041 4.59718 14.8617C4.84019 14.1564 4.70254 13.3758 4.23298 12.7962C3.4057 11.7751 3.67317 10.2582 4.7998 9.58164C5.43926 9.19762 5.83561 8.51112 5.84845 7.76532C5.87107 6.45134 7.051 5.46126 8.34895 5.66716C9.08564 5.78402 9.83054 5.5129 10.3198 4.94984Z",
    fill: "url(#paint0_radial_3_10)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14247 8.48706L4.7998 9.58164L4.14247 8.48706C2.35052 9.56318 1.92511 11.9759 3.24093 13.6L4.21478 12.811L3.24093 13.6C3.43319 13.8373 3.48956 14.1569 3.39005 14.4457C2.70906 16.4219 3.934 18.5435 5.98594 18.9419C6.28576 19.0001 6.53441 19.2087 6.64379 19.4939C7.3924 21.4455 9.69454 22.2834 11.5225 21.2696C11.7896 21.1215 12.1141 21.1215 12.3812 21.2696C14.2092 22.2834 16.5113 21.4455 17.2599 19.4939C17.3693 19.2087 17.6179 19.0001 17.9178 18.9419C19.9697 18.5435 21.1946 16.4219 20.5136 14.4457C20.4141 14.1569 20.4705 13.8373 20.6628 13.6C21.9786 11.9759 21.5532 9.56318 19.7612 8.48706C19.4994 8.32982 19.3371 8.04872 19.3318 7.74335C19.2959 5.65341 17.4191 4.07865 15.3547 4.40614C15.0531 4.45399 14.7481 4.34297 14.5477 4.11242C13.1768 2.53457 10.7269 2.53457 9.35596 4.11242C9.15564 4.34297 8.85063 4.45399 8.54898 4.40614C6.48456 4.07865 4.60783 5.65341 4.57185 7.74335C4.5666 8.04872 4.40431 8.32982 4.14247 8.48706Z",
    stroke: "url(#paint1_radial_3_10)",
    strokeOpacity: 0.4,
    strokeWidth: 2.55357
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.468 5.07867C11.2517 4.17677 12.652 4.17677 13.4357 5.07867C13.9693 5.69288 14.7819 5.98864 15.5855 5.86116C16.7656 5.67397 17.8383 6.5741 17.8588 7.7687C17.8729 8.58225 18.3052 9.33113 19.0028 9.75004C20.027 10.3651 20.2702 11.7442 19.5181 12.6726C19.0059 13.3048 18.8557 14.1564 19.1208 14.9256C19.5101 16.0552 18.8099 17.268 17.637 17.4957C16.8382 17.6507 16.1758 18.2066 15.8844 18.9663C15.4565 20.0818 14.1406 20.5607 13.0958 19.9813C12.3842 19.5866 11.5195 19.5866 10.8079 19.9813C9.76309 20.5607 8.44719 20.0818 8.01928 18.9663C7.72787 18.2066 7.06545 17.6507 6.26669 17.4957C5.09381 17.268 4.39363 16.0552 4.78289 14.9256C5.04798 14.1564 4.89782 13.3048 4.38561 12.6726C3.63348 11.7442 3.87665 10.3651 4.90093 9.75004C5.59848 9.33113 6.03085 8.58225 6.04485 7.7687C6.06541 6.5741 7.13815 5.67397 8.31817 5.86116C9.1218 5.98864 9.93437 5.69288 10.468 5.07867Z",
    stroke: "white",
    strokeWidth: 0.392857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9268,
    cy: 10.7579,
    r: 1.87835,
    transform: "rotate(-22.8443 13.9268 10.7579)",
    fill: "#844B8C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.88718,
    cy: 14.9056,
    r: 1.25223,
    transform: "rotate(-22.8443 9.88718 14.9056)",
    fill: "#844B8C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9518 12.5) rotate(90) scale(9.42857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#A94CA7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#A94CA7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9518 12.5) rotate(90) scale(9.42857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#844B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844B8C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbe);
export default __webpack_public_path__ + "static/media/ube.4c39c0081e32b445b22ada190a05296f.svg";
export { ForwardRef as ReactComponent };